import React, { useState, useEffect } from 'react'
import { Card, CardHeader } from 'reactstrap'
import Slide1 from './Slide1'
import Slide2 from './Slide2'
import Slide3 from './Slide3'
import Slide4 from './Slide4'
import Slide5 from './Slide5'
import Slide6 from './Slide6'
import Slide7 from './Slide7'
import Slide8 from './Slide8'
import Slide9 from './Slide9'
import RenderIf from './RenderIf'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'
import numeral from 'numeral'
import SwipeableViews from 'react-swipeable-views'
import _ from 'lodash'
const CardSlider = ({ set, step, estimate, currentPageIndex }) => {
  const style = {
    slideContainer: {
      minHeight: 700,
      maxHeight: `100%`,
      overflow: `hidden`
    },
    slideStyle: {
      minHeight: 550,
      overflow: 'hidden'
    }
  }
  const swipeableViewsRef = React.useRef(null)
  const _scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  const _updateSlideHeight = () => {
    // Needs to be on slight delay so it doesn't update height before the page was fully rendered
    setTimeout(() => {
      swipeableViewsRef.current
        .getChildContext()
        .swipeableViews.slideUpdateHeight()
    }, 250)
  }

  useEffect(() => {
    const handleResize = _.throttle((status) => {
      _updateSlideHeight()
    }, 1000)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // Used to update the slide's height as soon as the component mounts
  useEffect(() => {
    _updateSlideHeight()
  }, [])

  const [percentage, setPercentage] = useState(0)
  const [isLastSlide, setIsLastSlide] = useState(false)

  const MIN = 0
  const MAX = 800
  const totalSteps = 7

  const onNextRequested = () => {
    let newPercentage = percentage >= MAX ? MAX : percentage + 100

    if (percentage >= 700) {
      setIsLastSlide(true)
    }

    setPercentage(newPercentage)
    set('pageIndex', currentPageIndex + 1)
    _scrollToTop()
  }

  const onPrevRequested = () => {
    let newPercentage = percentage <= MIN ? MIN : percentage - 100
    setIsLastSlide(false)
    setPercentage(newPercentage)
    set('pageIndex', currentPageIndex - 1)
    _scrollToTop()
  }

  const onIncrementProgress = () => {
    const newStep = step === totalSteps ? totalSteps : step + 1
    set('step', newStep)
  }

  const onDecrementProgress = () => {
    const newStep = step === 0 ? 0 : step - 1
    set('step', newStep)
  }

  return (
    <div className='CardSlider'>
      <Card>

        <RenderIf condition={!isLastSlide}>
          <CardHeader className='d-flex justify-content-between align-items-end flex-wrap'>
            <div className='wrapper-progress'>
              <h3>PROGRESS</h3>
              <div className='d-flex mb-3'>
                <div className='position-relative'>
                  <div className={clsx('progress-step-first', { 'progress-step-first--filled': step >= 1 })} />
                </div>
                <div className={clsx('progress-step', 'progress-step--empty', { 'progress-step--filled': step >= 2 })} />
                <div className={clsx('progress-step', 'progress-step--empty', { 'progress-step--filled': step >= 3 })} />
                <div className={clsx('progress-step', 'progress-step--empty', { 'progress-step--filled': step >= 4 })} />
                <div className={clsx('progress-step', 'progress-step--empty', { 'progress-step--filled': step >= 5 })} />
                <div className={clsx('progress-step', 'progress-step--empty', { 'progress-step--filled': step >= 6 })} />
                <div className={clsx('progress-step', 'progress-step--empty', { 'progress-step--filled': step >= 7 })} />
              </div>
            </div>
            <RenderIf condition={step === 4 || step === 5 || step === 6}>
              <h2>Estimate {numeral(estimate).format('$0,000')}</h2>
            </RenderIf>
          </CardHeader>
        </RenderIf>
        <SwipeableViews
          style={style.slideContainer}
          animateHeight
          disabled
          enableMouseEvents={false}
          index={currentPageIndex}
          ref={swipeableViewsRef}
          slideStyle={style.slideStyle}
        >
          <Slide1 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} />
          <Slide2 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} onIncrementProgress={onIncrementProgress} onDecrementProgress={onDecrementProgress} />
          <Slide3 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} onIncrementProgress={onIncrementProgress} onDecrementProgress={onDecrementProgress} />
          <Slide4 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} onIncrementProgress={onIncrementProgress} onDecrementProgress={onDecrementProgress} isActive={step === 3} />
          <Slide5 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} onIncrementProgress={onIncrementProgress} onDecrementProgress={onDecrementProgress} isActive={step === 4} />
          <Slide6 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} onIncrementProgress={onIncrementProgress} onDecrementProgress={onDecrementProgress} isActive={step === 5} />
          <Slide7 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} onIncrementProgress={onIncrementProgress} onDecrementProgress={onDecrementProgress} />
          <Slide8 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} onIncrementProgress={onIncrementProgress} onDecrementProgress={onDecrementProgress} />
          <Slide9 onPrevRequested={onPrevRequested} onNextRequested={onNextRequested} />
        </SwipeableViews>
      </Card>
    </div>
  )
}

const mapStateToProps = (state, props) => ({
  step: state.app.step,
  estimate: state.app.estimate,
  currentPageIndex: state.app.pageIndex
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CardSlider)
